import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import type { NodeProps } from "reactflow";
import "../../styles/components/CustomNode.css";

interface ActionNodeProps extends NodeProps {
  data: any;
}

const ActionNode: React.FC<ActionNodeProps> = ({ data, selected }) => {
  // Generic config preview
  const getConfigPreviews = () => {
    const config = data.config || {};
    const previews: { label: string; value: string }[] = [];

    // Get first 2 non-empty config entries
    Object.entries(config)
      .filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
      .slice(0, 2)
      .forEach(([key, value]) => {
        previews.push({
          label: key.charAt(0).toUpperCase() + key.slice(1),
          value: String(value),
        });
      });

    return previews;
  };

  const configPreviews = getConfigPreviews();

  return (
    <div className={`custom-node node-action ${selected ? "selected" : ""}`}>
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="node-handle"
        style={{ background: data.color || "#10b981" }}
      />

      <div className="node-header">
        <div className="node-header-icon">{data.icon || "⚙️"}</div>
        <div className="node-header-title">{data.label || "Action"}</div>
      </div>

      <div className="node-body">
        {data.nodeKey && (
          <div className="node-field">
            <div className="node-field-label">Type:</div>
            <div className="node-field-value">{data.nodeKey}</div>
          </div>
        )}
        {configPreviews.length > 0 ? (
          configPreviews.map((preview, idx) => (
            <div key={idx} className="node-field">
              <div className="node-field-label">{preview.label}:</div>
              <div className="node-field-value">
                {preview.value.substring(0, 20)}
                {preview.value.length > 20 ? "..." : ""}
              </div>
            </div>
          ))
        ) : (
          <div className="node-field">
            <div className="node-field-value" style={{ color: "#666" }}>
              Not configured
            </div>
          </div>
        )}
      </div>

      {/* Output handle for chaining actions */}
      <Handle
        type="source"
        position={Position.Right}
        className="node-handle"
        style={{ background: data.color || "#10b981" }}
      />
    </div>
  );
};

export default memo(ActionNode);
